<template>
  <div
    class="c-cell" :class="classes"
    v-ripple="ripple"
    @click="onClick($event)"
  >
    <div class="c-cell__day">
      <span>{{day}}</span>
    </div>
    <div class="c-cell__season"/>
    <div class="c-cell__state">
      <svg v-if="stateImage" class="c-cell__stateimg" width="20" height="20">
        <use :href="stateImage"/>
      </svg>
    </div>
  </div>
</template>

<style lang="scss">
/* Element: セル */
.c-calendar-month .c-cell {
  cursor: default;

  .v-calendar-weekly__day.v-past &,
  .v-calendar-weekly__day.v-outside & {
    color: map-get($material-theme, 'text', 'disabled');
    cursor: default;
  }
}

/* Element: 日付 */
.c-calendar-month .c-cell__day {
  margin-top: .125rem;
  padding: .125rem .25rem .25rem;
  @include typo('body-2', $weight: bold);
  color: map-get(map-get($material-light, 'text'), 'disabled');
  text-align: right;

  .v-application.theme--dark & {
    color: map-get(map-get($material-dark, 'text'), 'disabled');
  }

  > span {
    display: inline-block;
    width: 20px;
    text-align: center;
  }
}

/* Element: シーズン */
.c-calendar-month .c-cell__season {
  $border-lt: rgba(black, .08);
  $border-rb: rgba(white, .24);

  margin-left: 4px;
  margin-right: 4px;
  margin-bottom: 1px;

  height: 3px;

  background-color: #E0E0E0;
  border-width: thin;
  border-style: solid;
  border-color: $border-lt $border-rb $border-rb $border-lt;
}

/* Element: 状態 */
.c-calendar-month .c-cell__state {
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Modifier: カレンダー外 */
.c-calendar-month .c-cell--outside {
  .c-cell__season {
    visibility: hidden;
  }
}

/* Modifier: 日曜日 */
.c-calendar-month .c-cell--w0 {
  .c-cell__day {
    color: var(--v-cal-holiday-base) !important;
  }
}

/* Modifier: 土曜日 */
.c-calendar-month .c-cell--w6 {
  .c-cell__day {
    color: var(--v-cal-saturday-base) !important;
  }
}

/* Modifier: 祝祭日 */
.c-calendar-month .c-cell--holiday {
  .c-cell__day {
    color: #ffffff !important;

    > span {
      background-color: var(--v-cal-holiday-base);
      border-radius: 50%;
    }
  }
}

/* Modifier: キャンペーンシーズン */
.c-calendar-month .c-cell--campaign {
  .c-cell__season {
    background-color: var(--v-cal-campaign-base);
  }
}

/* Modifier: ハイシーズン */
.c-calendar-month .c-cell--high {
  .c-cell__season {
    background-color: var(--v-cal-high-base);
  }
}

/* Modifier: 終日予約可 */
.c-calendar-month .c-cell--empty {
  cursor: pointer;

  .c-cell__stateimg {
    color: var(--v-cal-empty-base);
  }
}

/* Modifier: 一部予約可 */
.c-calendar-month .c-cell--afew {
  cursor: pointer;

  .c-cell__stateimg {
    color: var(--v-cal-afew-base);
  }
}

/* Modifier: 予約不可 */
.c-calendar-month .c-cell--occupied {
  .c-cell__stateimg {
    color: var(--v-cal-occupied-base);
  }
}

/* Modifier: 定休日 */
.c-calendar-month .c-cell--closed {
  cursor: default;

  .c-cell__stateimg {
    color: var(--v-cal-closed-base);
  }
}

/* Modifier: 選択した日付（出発日） */
.c-cell--selected-begin {
  animation: c-cell--blink 0.8s infinite alternate;
}
@keyframes c-cell--blink {
  0%{ background:white }
  100%{ background:pink }
}
/* Modifier: 選択した日付（間の日） */
.c-cell--selected {
  background-color: pink;
}
</style>

<script>
import DayStates from '@/assets/day-states.svg'

export default {
  name: 'CCell',

  props: {
    day: Number,
    date: Object,
    state: String,
    anytime: Number,
    startDate: Object,
    returnDate: Object,
    span: Object,
    spanText: String
  },
  computed: {
    classes () {
      if (!this.date || !this.state) {
        return 'c-cell--outside'
      }
      let str = this.date.classes
      if (this.anytime === 1) {
        str = str.replace('c-cell--closed ', '')
      }

      // 出発日のみ選択済
      if (this.startDate.date === this.date.date && this.returnDate.date === 'ご選択ください') {
        str = str + ' c-cell--selected-begin'
        return `${str} ${this.state}`
      }

      // 日付選択済
      if (this.startDate.date !== 'ご選択ください' && this.returnDate.date !== 'ご選択ください') {
      } else {
        return `${str} ${this.state}`
      }

      // 選択した日付のクラス
      if (this.startDate.date <= this.date.date && this.returnDate.date >= this.date.date) {
        str = str + ' c-cell--selected'
      }

      return `${str} ${this.state}`
    },

    stateImage () {
      if (!this.date || !this.state) {
        return null
      }
      let imgid = ''
      if (this.date.closed && this.anytime === 0) {
        imgid = 'closed'
      } else if (this.state === 'c-cell--occupied') {
        imgid = 'occupied'
      } else if (this.state === 'c-cell--afew') {
        imgid = 'afew'
      } else {
        imgid = 'empty'
      }
      return DayStates + '#' + imgid
    },

    clickable () {
      if (!this.date || !this.state) {
        return false
      }
      if ((this.date.closed && this.anytime === 0) || this.state === 'c-cell--occupied') {
        return false
      }
      return true
    },

    ripple () {
      return !this.clickable ? null : { center: false, class: 'v-ripple' }
    }
  },
  methods: {
    onClick (event) {
      // console.log(this.span)
      if (!this.clickable) {
        return
      }

      const wdate = {
        startDate: {},
        returnDate: {}
      }

      if (this.startDate.date === 'ご選択ください' || this.returnDate.date !== 'ご選択ください') {
        wdate.startDate = this.date
        wdate.returnDate.date = 'ご選択ください'
      } else {
        if (this.startDate.date < this.date.date) {
          wdate.startDate = this.startDate
          wdate.returnDate = this.date
        } else {
          wdate.startDate = this.date
          wdate.returnDate = this.startDate
        }
        if (this.checkDays(wdate.startDate.date, wdate.returnDate.date)) {
        } else {
          alert(this.spanText + ' 内で日付を選択してください')
          return
        }
      }

      this.$emit('child_selectDate', wdate)
    },

    checkDays (begin, end) {
      if (begin === end) {
        return true
      }

      if (end >= this.spanDate(begin, this.span.max)) {
        return false
      }

      if (end < this.spanDate(begin, this.span.min)) {
        return false
      }

      return true
    },

    spanDate (date, span) {
      const spanArr = span.split(' ')
      const wDate = new Date(date)

      // 日付を算出
      switch (spanArr[1]) {
        case 'days':
          wDate.setDate(wDate.getDate() + parseInt(spanArr[0]))
          break
        case 'weeks':
          wDate.setDate(wDate.getDate() + (parseInt(spanArr[0]) * 7))
          break
        case 'month':
          wDate.setMonth(wDate.getMonth() + parseInt(spanArr[0]))
          break
      }

      const yyyy = wDate.getFullYear()
      const mm = ('00' + (wDate.getMonth() + 1)).slice(-2)
      const dd = ('00' + wDate.getDate()).slice(-2)
      const yyyymmdd = yyyy + '-' + mm + '-' + dd

      // console.log(span + ' : ' + date + ' -> ' + yyyymmdd)
      return yyyymmdd
    }
  }
}
</script>
